import Banking from "../../../../images/categories/banking.webp";
import Insurance from "../../../../images/categories/insurance.webp";
import RealEstate from "../../../../images/categories/real-estate.webp";
import Accounting from "../../../../images/categories/accounting.webp";
import AssetManagement from "../../../../images/categories/asset-management.webp";
import CryptoAndOther from "../../../../images/categories/crypto-and-other.webp";
import FintechsAndPayments from "../../../../images/categories/fintechs-and-payment.webp";
import GamingAndGambling from "../../../../images/categories/gaming-and-gambling.webp";
import LegalServices from "../../../../images/categories/legal-services.webp";

export type CategoryTranslation = {
    id: number;
    category_id: number;
    name: string;
    slug: string;
    url_path: string;
    description: string | null;
    meta_title: string | null;
    meta_description: string | null;
    meta_keywords: string | null;
    locale_id: number | null;
    locale: string;
};

export type CategoryMeta = {
    title: string | null;
    keywords: string | null;
    description: string | null;
};

export type Category = {
    id: number;
    parent_id: number | null;
    name: string;
    slug: string;
    status: number;
    position: number;
    display_mode: string;
    description: string | null;
    meta: CategoryMeta;
    translations: CategoryTranslation[];
    additional: any[];
    children?: Category[];
};

export type PaginationLinks = {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
};

export type MetaLink = {
    url: string | null;
    label: string;
    active: boolean;
};

export type PaginationMeta = {
    current_page: number;
    from: number;
    last_page: number;
    links: MetaLink[];
    path: string;
    per_page: number;
    to: number;
    total: number;
};

export type CategoryResponse = {
    data: Category[];
    links: PaginationLinks;
    meta: PaginationMeta;
};

export const CATEGORIES_IMAGES = {
    banking: Banking,
    insurance: Insurance,
    "real-estate": RealEstate,
    accounting: Accounting,
    "legal-services": LegalServices,
    "fintechs-&-payments": FintechsAndPayments,
    "asset-management": AssetManagement,
    "gaming-&-gambling": GamingAndGambling,
    "crypto-&-other": CryptoAndOther,
} as const;